import * as types from './mutation_types';

export default {
  [types.UID](state, uid) {
    state.uid = uid;
  },
  [types.ERROR_STATE](state, errorState) {
    state.errorState = errorState;
  },
  [types.IS_AUTH](state, isAuth) {
    state.isAuth = isAuth;
  },
  [types.MENUS](state, menus) {
    state.menus = menus;
  },
  [types.LOCALE](state, locale) {
    state.locale = locale;
  },
  [types.PARAMS](state, params) {
    state.params = params;
  },
  [types.AUTH_INFO](state, params) {
    state.authInfo = params;
  },
  [types.HIGHEST_ROLE](state, params) {
    state.highestRole = params;
  },
  [types.API_ERROR_CODE](state, params) {
    state.apiErrorCode = params;
  },
  [types.LOGOUT_CALLED](state, params) {
    state.logoutCalled = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/mutations.js